export type ImprintContact = {
  companyName: string;
  owner: string;
  address: string;
  email: string;
  phone: string;
  registration: string;
  taxId: string;
};

// Reference details supplied in the conversation. Email and phone were explicitly excluded.
// Keep this as a reviewable code change; do not overwrite live CMS records.
export const IMPRINT_REFERENCE = {
  companyName: "Seraser Investment Ltd.",
  address: "Malkocoglu Sokak\nSeraser Apt., Daire: 12\nKyrenia\nTürkische Republik Nordzypern",
} as const;

export function resolveImprintContact(input: unknown): ImprintContact {
  const values = input && typeof input === "object" ? input as Record<string, unknown> : {};
  const text = (key: string) => typeof values[key] === "string" ? values[key].trim() : "";
  const companyName = text("companyName") || IMPRINT_REFERENCE.companyName;
  return {
    companyName,
    address: text("address") || (companyName === IMPRINT_REFERENCE.companyName ? IMPRINT_REFERENCE.address : ""),
    owner: text("owner"),
    email: text("email"),
    phone: text("phone"),
    registration: text("registration"),
    taxId: text("taxId"),
  };
}
